import React from 'react'
import ReusableButton from '../../reusableComponents/button/customButton'
import './index.scss'
import { connect } from 'react-redux'
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils'
import LockIcon from '../../../../../asset/unlock-white.png'

const UpgradeButton = (props) => {
  let upgrade = (auth) => {
    console.log(auth)
    showHideSubscriptionModal(auth)
  }
  return (
    <div>
      <div style={{
        height: '80px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
        className='unit-card'>
        <ReusableButton
          className={`lets-go-button lets-go-button-label ${props.className ? props.className : ''}`}
          style={{ minHeight: '30px' }}
          label={props.label ? props.label : "Unlock Data"}
          onClick={() => upgrade(props.auth.token)}
          variant="primary"
          size="small"
          buttonWidth='120px'
          buttonHeight="30px"
          icon={LockIcon}
        />


        <p style={{
          font: 'normal normal 200 12px/14px Roboto',
          width: props.discription ? 250 : '',
          textAlign: 'center',
          letterSpacing: '0.5px'
        }}>{props.discription ? props.discription : 'Upgrade to view detailed hunting info, Unit score, Trophy potential, draw odds and harvest trends'}</p>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  currentSubscription: state.currentSubscription
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeButton)
